"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Member';
exports.packageGroup = 'member';
exports.apiPathGroup = 'members';
exports.routerPathGroup = 'member';
